import React from 'react';
import styled from 'styled-components';
import {AppContext} from '../App/AppProvider';
import {fontSize1, greenBoxShadow, color3} from '../Shared/Styles';

const ConfirmButtonStyled = styled.div`
  margin: 20px;
  color: ${color3};
  ${fontSize1};
  padding: 5px;
  cursor: pointer;
  &:hover {
    ${greenBoxShadow}
  }
`

export const CenterDiv = styled.div`
  display: grid;
  justify-content: center;
`;

export default function () {
  return (
    <AppContext.Consumer>
      {({confirmFavorites, dummy}) => 
      <CenterDiv>
        {dummy.length 
        ?
        <ConfirmButtonStyled onClick={confirmFavorites}> 
          Confirm Favorites
        </ConfirmButtonStyled>
        :
        <ConfirmButtonStyled style={{color: "grey", borderColor: "grey", boxShadow: "0px 0px 2px 2px grey"}}>
          Confirm Favorites
        </ConfirmButtonStyled>
        }
        
      </CenterDiv>
      }
    </AppContext.Consumer>
  )
}